// extracted by mini-css-extract-plugin
export default {"wrapper":"informations_wrapper__jVIm8","image":"informations_image__9bO-G","inside":"informations_inside__Mtsft"};